import { render, staticRenderFns } from "./DeptAccess.vue?vue&type=template&id=4933493f&scoped=true&"
import script from "./DeptAccess.vue?vue&type=script&lang=js&"
export * from "./DeptAccess.vue?vue&type=script&lang=js&"
import style0 from "./DeptAccess.vue?vue&type=style&index=0&id=4933493f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4933493f",
  null
  
)

export default component.exports